import { IGNIS_RED, WHITE } from "@120wateraudit/waterworks";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import styled from "styled-components";

interface Props {
  onClose: () => void;
  onConfirm: () => Promise<unknown>;
}

const DeleteConfirmationModal = ({
  onClose,
  onConfirm,
}: Props): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const confirm: () => Promise<void> = async () => {
    setLoading(true);
    if (await onConfirm()) {
      onClose();
    }
    setLoading(false);
  };

  return (
    <>
      <ModalContentContainer>
        <ModalHeader>
          Are you sure you want to <span>delete</span>
          this submission period?
        </ModalHeader>
        <ContentHeader>
          Once a submission period is <span>deleted</span>, it cannot be
          recovered.
        </ContentHeader>
        <DeleteButtonWrapper>
          <DeleteButton disabled={loading} onClick={confirm}>
            Delete Submission Period
          </DeleteButton>
        </DeleteButtonWrapper>
        <Button disabled={loading} onClick={onClose}>
          Cancel
        </Button>
      </ModalContentContainer>
    </>
  );
};

const ModalContentContainer = styled.div`
  display: flex;
  margin: 0;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-bottom: 24px;
`;

const ModalHeader = styled.h3`
  display: flex;
  padding: 16px;
  font-weight: 600;
  text-align: left;
  padding-bottom: 0;
  margin-bottom: 0px;
  span {
    color: ${IGNIS_RED};
    padding: 0 5px;
  }
`;

const ContentHeader = styled.h4`
display: flex
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 0;
  span {
    color: ${IGNIS_RED};
  }
`;

const DeleteButtonWrapper = styled.div`
  margin-bottom: 1rem;
  margin-top: 2rem;
`;

const DeleteButton = styled(Button)`
  &&& {
    background-color: ${IGNIS_RED};
    color: ${WHITE};
  }
`;

export default DeleteConfirmationModal;
